import { getActiveParamFromIdComponentUI, getValuesFromIdAttribute } from "../../redux/selectors/ui.selector";
import { useAppSelector } from "../../utils/hooks";
import { ImgRadio } from "../ImgRadio/ImgRadio";
//@ts-ignore
import s from "./FinishGroup.module.scss";
import CashingMaterialsModal from "../Modals/CashingMaterialsModal/CashingMaterialsModal";
import { useEffect, useState } from "react";

export const FinishGroup = ({ ...props }: any) => {
  const { id, label, typeOptions, values, additionalProperties } = props;
  const [isOpen, setIsOpen] = useState(false);

  const valuesOptionsFromThreekit = useAppSelector((state) => getValuesFromIdAttribute(id)(state));
  const valueActiveParamUILegsSelector = useAppSelector(getActiveParamFromIdComponentUI("leg"));

  const isMetalLegs = !!valueActiveParamUILegsSelector && valueActiveParamUILegsSelector.includes("metal");

  const StyledLabel = () => {
    if (!!label && label.includes("Step")) {
      const stepPart = label.split(".")[0] + ".";
      const labelPart = label.split(".")[1];
      return (
        <div className={s.finishGroupTitle}>
          <span className={s.finishGroupTitle_accent}>{stepPart}</span>
          {labelPart}
        </div>
      );
    } else {
      return <div className={s.finishGroupTitle}>{label}</div>;
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const inStore = urlParams.get("inStore") === "true";
    const isCached = sessionStorage.getItem("materialsCached") === "true";

    if (inStore && !isCached) {
      setIsOpen(true);
    }
  }, []);

  return (
    <>
      <CashingMaterialsModal isOpen={isOpen} setOpen={setIsOpen} />
      <div className={s.finishGroup}>
        {!!label && <StyledLabel />}
        <div className={s.finishGroupRow}>
          <ImgRadio {...props} values={valuesOptionsFromThreekit} label="" />
          {/*isMetalLegs ? (
                    <ImgRadio
                        {...props}
                        values={valuesOptionsFromThreekit}
                        label=""
                    />
                ) : (
                    <ImgRadio
                        {...props}
                        values={valuesOptionsFromThreekit}
                        label=""
                    />
                )*/}
        </div>
      </div>
    </>
  );
};
